


















































import Vue from 'vue';
import * as relazioneMedicaResponsabilitaApi from '../../services/relazione-medica-responsabilita-api';
import { RelazioneMedicaResponsabilitaEditViewModel } from '../../types';
import validationRulesMixin from '../../components/mixin/validation-rules-mixin';
import operatoreSanitarioSelector from '../selectors/OperatoreSanitarioSelector.vue';
export default Vue.extend({
    mixins: [validationRulesMixin],
    components: {
        operatoreSanitarioSelector,
    },
    props: {
        id: { default: 0 },
        relazioneMedicaId: { type: Number, required: true },
        assicurato: { type: Boolean, required: true },
    },
    data(): RelazioneMedicaResponsabilitaEditViewModel {
        return {
            item: null,
            isValid: false,
        };
    },
    computed: {
        isNew(): boolean {
            return this.item != null && this.item.id === 0;
        },
        getRelazioneMedicaId(): number {
            return (
                this.relazioneMedicaId ??
                (this.item != null ? this.item.relazioneMedicaId : null)
            );
        },
    },
    methods: {
        async loadData(id: number): Promise<void> {
            if (id > 0) {
                this.item = await relazioneMedicaResponsabilitaApi.getByKey(id);
            } else {
                this.setNewItem();
            }
        },
        close() {
            this.$emit('close');
        },
        setNewItem() {
            this.item = {
                id: 0,
                version: 0,
                operatoreSanitarioId: 0,
                percentualeResponsabilita: 0,
                assicurato: this.assicurato,
                relazioneMedicaId: this.getRelazioneMedicaId,
            };
        },
        async save() {
            if (!this.item) {
                return;
            }
            let response = null;
            if (this.isNew) {
                response = await relazioneMedicaResponsabilitaApi.create(
                    this.item
                );
            } else {
                response = await relazioneMedicaResponsabilitaApi.update(
                    this.item
                );
            }
            await this.loadData(response.id);
            this.$emit('save', this.item);
        },
    },
    async mounted() {
        setTimeout(() => {
            this.isValid = (this.$refs.form as HTMLFormElement).validate();
        });
    },
    watch: {
        id: {
            handler: async function (val) {
                await this.loadData(val);
            },
            immediate: true,
        },
    },
});
